namespace SP {
    export enum ShipmentLineDataType {
        BatchNumber = 1,
        SerialNumber = 2,
        ExpirationDate = 3 
    }
}